import React from "react";

const getDisplayName = (name) => {
  const reg = /_[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/;
  return name.replace(reg, "");
};

const ErrorList = ({ reports, activeReport, onSelectReport }) => {
  return (
    <div
      style={{ overflowY: "scroll", overflowX: "hidden", height: "calc(100vh - 330px)" }}
      className="panel is-link is-radiusless is-shadowless"
    >
      {reports.map((report) => (
        <a
          href="/"
          className={`panel-block ${activeReport?.id === report.id ? "is-active" : ""}`}
          onClick={(event) => {
            event.preventDefault();
            onSelectReport(report);
          }}
          key={`${report.id}`}
        >
          <span className="panel-icon">
            <i className="fas fa-info-circle" aria-hidden="true" />
          </span>
          <p className={`is-size-7 has-text-weight-semibold ${activeReport?.id === report.id ? "has-text-link" : ""}`}>
            {getDisplayName(report.fileName).trim()}
          </p>
        </a>
      ))}
    </div>
  );
};

export default ErrorList;
